import type { JSX } from 'react';
import { ConfigSection } from '../components/ConfigSection.js';

export function SecurityPage(): JSX.Element {
  return (
    <ConfigSection
      title={"Segurança: MFA, sessões e bootstrap"}
      description={"Área do plano que depende de código ou credencial externa."}
      blockedBy={[
      'MFA do admin está implementado na API (`/v1/auth/mfa/enroll|confirm`) e não tem tela nesta revisão.',
      'Bootstrap do primeiro admin é feito por comando one-time com `ADMIN_BOOTSTRAP_*` (sem senha padrão).',
      'OAuth (Google/Apple) para o app depende de credenciais e não está implementado.'
]}
      planned={[
      'Sessões com TTL curto, revogação com reautenticação e auditoria de acesso.',
      'Nenhum administrador pode fabricar aceite, consentimento ou data de compromisso.'
]}
    />
  );
}